import { render, staticRenderFns } from "./ProjectPlace.vue?vue&type=template&id=1b5bfeb8&scoped=true&"
import script from "./ProjectPlace.vue?vue&type=script&lang=js&"
export * from "./ProjectPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5bfeb8",
  null
  
)

export default component.exports